<template>
	<div>
		<vs-table search stripe :data="product" max-items="5" pagination>
			<template slot="header">
				<h1>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
						Productos<br>
					</vs-col>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
						<vs-button @click="createProductPrompt()" radius color="success" type="border" icon="add"></vs-button>
					</vs-col>
					<vs-prompt @cancel="val=''" @accept="createProduct" :active.sync="activePrompt2" title="Crear Producto" :is-valid="validName">
						<div class="con-exemple-prompt">
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
									<div class="borderSubMenu">
										<div class="titleProduct">
											Producto
										</div>
										<vs-select class="selectExample" label="Proveedor" v-model="idProvider">
											<vs-select-item size="small" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in clients"/>
										</vs-select>						
										<vs-input size="small" label="Marca" v-model="brand"/>
										<vs-input size="small" label="Registro Sanitario" v-model="health_record"/>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Peso neto" v-model="weight"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="wProduct">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in weights"/>
												</vs-select>
											</vs-col>
										</div>
										<vs-input size="small" label="Observación" v-model="observation"/>
									</div>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<div class="borderSubMenu">
										<div class="titleProduct">
											Caja 
										</div>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Ancho" v-model="width"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="dWidth">
													<vs-select-item size="small" :key="i" :value="item.value" :text="item.text" v-for="(item,i) in distance"/>
												</vs-select>
											</vs-col>
										</div>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Largo" v-model="long"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="dLong">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in distance"/>
												</vs-select>
											</vs-col>
										</div>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Alto" v-model="high"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="dHigh">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in distance"/>
												</vs-select>
											</vs-col>
										</div>

										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Peso" v-model="weight_by_box"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="wByBox">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in weights"/>
												</vs-select>
											</vs-col>
										</div>
										<vs-input size="small" label="Cantidad" v-model="quanty_by_box"/>
									</div>
									<vs-alert :active="!validName" color="danger" icon="new_releases" class="emptyWarning">
										Completar campos
									</vs-alert>
								</vs-col>

							<!-- <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >						
									<vs-input size="small" label="Marca" v-model="brand"/>
									<vs-input size="small" label="Registro Sanitario" v-model="health_record"/>
									<vs-input size="small" label="Peso neto" v-model="weight"/>
									<vs-input size="small" label="Peso por caja" v-model="weight_by_box"/>
									<vs-input size="small" label="Cantidad por caja" v-model="quanty_by_box"/>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<vs-select class="selectExample" label="Proveedor" v-model="idProvider">
										<vs-select-item size="small" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in clients"/>
									</vs-select>
									<vs-input size="small" label="Ancho de caja" v-model="width"/>
									<vs-input size="small" label="Largo de caja" v-model="long"/>
									<vs-input size="small" label="Alto de caja" v-model="high"/>
									<vs-input size="small" label="Observación" v-model="observation"/>
									<vs-alert :active="!validName" color="danger" icon="new_releases" class="emptyWarning">
										Completar campos
									</vs-alert>
								</vs-col> -->
						</div>
					</vs-prompt>
					
				</h1>
			</template>
			<template slot="thead">
				
				<vs-th>
					Proveedor
				</vs-th>
				<vs-th >
					Marca
				</vs-th>
				<vs-th>
					Peso (Kg)
				</vs-th>
				<vs-th>
					Observación
				</vs-th>
				<vs-th>
					Editar
				</vs-th>
				
				
			</template>

			<template slot-scope="{data}">
				<vs-tr :state="indextr == 1 ?'success':indextr == 3?'success':null" :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].providerData.name">
						{{data[indextr].providerData.name}}
						<!-- <template slot="edit">
							<vs-input v-model="data[indextr].providerData" class="inputx" placeholder="Nombre"/>
						</template> -->
					</vs-td>

					<vs-td :data="data[indextr].brand">
						{{data[indextr].brand}}
					</vs-td>

					<vs-td :data="data[indextr].weight">
						{{data[indextr].weight}}
					</vs-td>

					<vs-td :data="data[indextr].observation">
						{{data[indextr].observation}}
					</vs-td>

					<vs-td :data="data[indextr].id">
						<vs-button  @click="editProductPrompt(tr)" vs-type="gradient" size="small" color="success" icon="edit"></vs-button>
						<vs-prompt @cancel="val=''" @accept="editProduct" :active.sync="activePrompt" title="Editar Producto">
							<div class="con-exemple-prompt">
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
									<div class="borderSubMenu">
										<div class="titleProduct">
											Producto
										</div>
										<vs-select class="selectExample" label="Proveedor" v-model="idProvider">
											<vs-select-item size="small" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in clients"/>
										</vs-select>						
										<vs-input size="small" label="Marca" v-model="brand"/>
										<vs-input size="small" label="Registro Sanitario" v-model="health_record"/>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Peso neto" v-model="weight"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="wProduct">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in weights"/>
												</vs-select>
											</vs-col>
										</div>
										<vs-input size="small" label="Observación" v-model="observation"/>
									</div>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
									<div class="borderSubMenu">
										<div class="titleProduct">
											Caja 
										</div>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Ancho" v-model="width"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="dWidth">
													<vs-select-item size="small" :key="i" :value="item.value" :text="item.text" v-for="(item,i) in distance"/>
												</vs-select>
											</vs-col>
										</div>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Largo" v-model="long"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="dLong">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in distance"/>
												</vs-select>
											</vs-col>
										</div>
										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Alto" v-model="high"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="dHigh">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in distance"/>
												</vs-select>
											</vs-col>
										</div>

										<div>
											<vs-col type="flex" vs-w="7">
												<vs-input size="small" label="Peso" v-model="weight_by_box"/>
											</vs-col>
											<vs-col type="flex" vs-w="5">
												<vs-select class="selectExample" label="Unidad" v-model="wByBox">
													<vs-select-item size="small" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in weights"/>
												</vs-select>
											</vs-col>
										</div>
										<vs-input size="small" label="Cantidad" v-model="quanty_by_box"/>
									</div>
										
								</vs-col>
							</div>
						</vs-prompt>
					</vs-td>
					<!-- <vs-td :data="data[indextr].created_at">
						{{ getHumanDate(data[indextr].created_at) }} 
					</vs-td> -->
					<template class="expand-user" slot="expand">
							<vs-list>
								<vs-list-item :title="tr.providerData.name" subtitle="Proveedor">
									<template slot="avatar">
										<vs-avatar size="45px" :src="`${tr.providerData.logo}`"/>
									</template>
								</vs-list-item>
								<div>
									<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
										<vs-list-item icon="note" title="Registro Sanitario" :subtitle="tr.health_record"></vs-list-item>
										<vs-list-item icon="save_alt" title="Peso por caja (Kg)" :subtitle="tr.weight_by_box.toString()"></vs-list-item>
										<vs-list-item icon="local_grocery_store" title="Cantidad por caja" :subtitle="tr.quanty_by_box.toString()"></vs-list-item>
									</vs-col>
									<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
										<vs-list-item icon="square_foot" title="Ancho de caja (mts)" :subtitle="tr.width.toString()"></vs-list-item>
										<vs-list-item icon="square_foot" title="Largo de caja (mts)" :subtitle="tr.long.toString()"></vs-list-item>
										<vs-list-item icon="square_foot" title="Alto de caja (mts)" :subtitle="tr.high.toString()"></vs-list-item>
									</vs-col>
								</div>
										

							</vs-list>
							<div class="con-btns-user">
								<div>
									<vs-button @click="openConfirm(tr.id, tr.providerData)" vs-type="flat" size="medium" color="danger" icon="delete_sweep"></vs-button>
								</div>
							</div>
					</template>
				</vs-tr>
			</template>

    </vs-table>
	<!-- <pre>{{ selected }}</pre> -->

	</div>
</template>

<script>

import moment from 'moment';

export default {
	data(){
		return{
			product : [],
			val:'Producto',
			activePrompt:false,
			activePrompt2:false,
			activeConfirm:false,
			idProduct: 0,
			idProvider:0,
			providerData: "",
			health_record: "",
			quanty_by_box: "",
			weight_by_box: "",
			brand: "",
			weight: "",
			width:"",
			long:"",
			high:"",
			observation: "",
			logo:"",
			config:"",
			clients : [],
			dWidth : 0,
			dLong : 0,
			dHigh : 0,
			wByBox:0,
			wProduct:0,
			distance:[
				{text:'cm', value:0},
				{text:'mt', value:1},
				{text:'pulg', value:2},
			],
			weights:[
				{text:"Lb", value:0},
				{text:"Kg", value:1},
				{text:"g", value:2}
			],
		}
	},
	computed:{
		validName(){
			return (this.health_record.length > 0 && this.quanty_by_box.length > 0 && this.weight_by_box.length > 0 && this.brand.length > 0 && this.weight.length > 0 &&  this.width.length > 0 && this.long.length > 0 && this.high.length > 0 && this.observation.length > 0)
		}
	},
	methods: {
		getProducts(){
			const path = '/product/'
			this.$http.get(path).then((response) => {
				this.product = response.data
				console.log(this.product)
			})
			.catch((error) => {
				console.log(error)
			})

			const path2 = '/provider/'
			this.$http.get(path2).then((response) => {
				this.clients = response.data.results
				console.log(this.clients)
			})
			.catch((error) => {
				console.log(error)
			})
		},
		editProduct(){
			const path = `/product/${this.idProduct}/` 
			if (this.dWidth == 0){this.width = this.width/100}
			else if(this.dWidth == 2){this.width = Math.round(this.width*1000/39.37)/1000}
			if (this.dLong == 0){this.long = this.long/100}
			else if(this.dLong == 2){this.long = Math.round(this.long*1000/39.37)/1000}
			if (this.dHigh == 0){this.high = this.high/100}
			else if(this.dHigh == 2){this.high = Math.round(this.high*1000/39.37)/1000}
			if (this.wProduct == 0){this.weight = Math.round(this.weight*1000/2.2046)/1000}
			else if (this.wProduct == 2){this.weight = this.weight/1000}
			if (this.wByBox == 0){this.weight_by_box = Math.round(this.weight_by_box*1000/2.2046)/1000}
			else if (this.wByBox == 2){this.weight_by_box = this.weight_by_box/1000}
			this.$http.patch(path, {
				provider: this.idProvider,
				health_record: this.health_record,
				quanty_by_box: this.quanty_by_box,
				weight_by_box: this.weight_by_box,
				brand: this.brand,
				weight: this.weight,
				width: this.width,
				long: this.long,
				high: this.high,
				observation: this.observation,
			})
			.then((response) => {
				console.log(response.data)
				this.getProducts()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:'Actualización de los datos del producto'
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser editado'
				})
			});	
		},
		deleteProduct(){
			const path = `/product/${this.idProduct}/` 
			this.$http.delete(path).then((response) => {
				console.log(response.data)
				this.getProducts()
				this.$vs.notify({
					color:'danger',
					title:'Registro eliminado',
					text:`El registro fue eliminado correctamente`
				})
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser eliminado'
				})
			})
			
		},
		createProduct(){
			console.log('aqui')
			const path = `/product/`
				// data.append('provider', this.idProvider);
				// data.append('health_record', this.health_record);
				// data.append('quanty_by_box', this.quanty_by_box);
				// data.append('weight_by_box', this.weight_by_box);
				// data.append('brand', this.brand);
				// data.append('weight', this.weight);
				// data.append('width', this.width);
				// data.append('long', this.long);
				// data.append('high', this.high);
				// data.append('observation', this.observation);

			this.$http.post(path, {
				provider: this.idProvider,
				health_record: this.health_record,
				quanty_by_box: this.quanty_by_box,
				weight_by_box: this.weight_by_box,
				brand: this.brand,
				weight: this.weight,
				width: this.width,
				long: this.long,
				high: this.high,
				observation: this.observation
			})
			.then((response) => {
				console.log(response.data)
				this.getProducts()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:`Creación del producto ${this.brand}`
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El producto no pudo ser creado'
				})
			});
		},
		openConfirm(id, c){
			this.idProduct = id,
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: `Confirmar`,
				text: `¿Desea eliminar al producto ${c}?`,
				accept:this.deleteProduct,
				acceptText:'Aceptar',
				cancelText:'Cancelar',
			})
		},
		editProductPrompt(id){
			this.idProduct = id["id"];
			this.idProvider = id["provider"];
			this.activePrompt = true;
			this.health_record= id["health_record"];
			this.quanty_by_box= id["quanty_by_box"];
			// this.weight_by_box= Math.round(id["weight_by_box"] * 2.2 * 100)/100;
			this.weight_by_box= id["weight_by_box"];
			this.brand= id["brand"];
			// this.weight= Math.round(id["weight"] * 2.2 * 100)/100;
			this.weight= id["weight"];
			this.width= id["width"];
			this.long= id["long"];
			this.high= id["high"];
			this.provider= id["providerData"]["name"];
			this.observation= id["observation"];
			this.logo= id["providerData"]["logo"];
			this.dWidth = 1;
			this.dLong = 1;
			this.dHigh = 1;
			this.wByBox= 1;
			this.wProduct= 1;
		},
		createProductPrompt(){
			this.idProduct = "";
			this.idProvider ="";
			this.activePrompt2 = true;
			this.health_record="";
			this.quanty_by_box="";
			this.weight_by_box="";
			this.brand="";
			this.weight="";
			this.width="";
			this.long="";
			this.high="";
			this.provider="";
			this.observation="";
			this.logo="";
			this.dWidth = 1;
			this.dLong = 1;
			this.dHigh = 1;
			this.wByBox= 1;
			this.wProduct= 1;
		},
		getHumanDate : function (date) {
			// return moment(date, 'YYYY-MM-DDTh:mm').format('DD/MM/YYYY, h:mm a');
			moment.locale('es');
			return moment(date, 'YYYY-MM-DDTh:mm').fromNow();
		},
	},
	created(){
		this.getProducts()
	}
}
</script>

<style lang="stylus">
.con-exemple-prompt
	padding 1px;
	padding-bottom 1px;
	.vs-input
		width 90%
		margin-top 1px;
.emptyWarning{
	width 90%;
	margin-top:10px;
}
.selectExample{
	width 90%;
	margin-top 1px;
	margin-left 5%;
}
.con-select .vs-select--input{
	font-size 0.75rem;
	padding 7px;
}
.titleProduct{
	font-size 1.3rem;
	justify-content center;
	width 90%;
	display grid;
	margin-left 5%;
	margin-top 5px;
}
.borderSubMenu{
	border 1px solid rgba(10,100,255,0.5);
	align-content rigth;
	display grid;
	border-radius 10px;
	padding-bottom 10px;
	margin-left 5px;
	.vs-input{
		margin-left 5%;

	}
}
</style>